module.exports = __webpack_public_path__ + "static/media/Test28.9ebb0c8c.bmp";